import React, { useEffect, useRef } from "react";
import { RiArrowUpLine } from "@remixicon/react";
import classNames from "classnames";
import Styles from "./AnswerDetails.module.scss";
import Button from "../../../components/theme/button/Button";
import Icon from "../../../components/theme/icon/Icon";

export default function BackToTop({ topRef } : {
    topRef: React.RefObject<HTMLDivElement>,
}) {
    const [shouldShow, setShouldShow] = React.useState(false);
    const markerRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(entries => {
            setShouldShow(!entries.firstElement.isIntersecting);
        });

        if (markerRef.current) {
            observer.observe(markerRef.current);
        }

        return () => {
            if (markerRef.current) {
                observer.unobserve(markerRef.current);
            }
        };
    }, []);
    return (
        <>
            <div ref={markerRef} />
            <div className={classNames(
                Styles["article-back-to-top"],
                "article-back-to-top",
                shouldShow ? Styles["article-back-to-top-show"] : Styles["article-back-to-top-hide"],
            )}
            >
                Back to Top
                <Button
                    variant="outline-gray"
                    size="small"
                    onClick={() => {
                        topRef.current?.scrollIntoView({
                            block: "start",
                            behavior: "smooth",
                        });
                    }}
                    prefixIcon={<Icon icon={<RiArrowUpLine />} />}
                />
            </div>
        </>
    );
}

export function useScrollTop(ref?: React.RefObject<HTMLDivElement>) {
    const topRef = useRef<HTMLDivElement>(null);

    return {
        topRef,
        element: <BackToTop topRef={ref ?? topRef} />,
    };
}
